<!-- Port of vendor-ref/mara/app/ui/src/components/NEmptyResult.vue -->
<script setup lang="ts">
withDefaults(defineProps<{ icon: string; item: string; search?: string }>(), { search: '' });
</script>

<template>
  <div class="my-4 p-4 flex flex-col gap-2 items-center op-50">
    <i :class="icon" class="text-3xl" />
    <div>No {{ item }} {{ search ? `found for "${search}"` : 'yet' }}</div>
    <slot />
  </div>
</template>
